import React from 'react'
import AmbulatoryInsuranceStepLayout from 'presentation/doctor/layouts/AmbulatoryInsuranceStep'

function AmbulatoryInsuranceStep() {
  return <AmbulatoryInsuranceStepLayout />
}

export default AmbulatoryInsuranceStep
